module.exports = __webpack_public_path__ + "static/media/BlueButton.4ca501cf.svg";